import { render, staticRenderFns } from "./advChannelRuleStatus.vue?vue&type=template&id=479556a4"
import script from "./advChannelRuleStatus.vue?vue&type=script&lang=js"
export * from "./advChannelRuleStatus.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports